import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { inventoryAPI } from '../../services/api';
import toast from 'react-hot-toast';
export default function InventoryAdjust() {
  const navigate = useNavigate(); const [products, setProducts] = useState([]); const [loading, setLoading] = useState(false);
  const [adjustDate, setAdjustDate] = useState(new Date().toISOString().split('T')[0]);
  const [adjustments, setAdjustments] = useState([]); const [reason, setReason] = useState('');
  useEffect(() => { inventoryAPI.list({}).then(setProducts); }, []);
  const addAdjustment = () => setAdjustments([...adjustments, { product_id: '', new_quantity: 0 }]);
  const update = (i,f,v) => { const a=[...adjustments]; a[i]={...a[i],[f]:v}; setAdjustments(a); };
  const handleSubmit = async(e) => { e.preventDefault(); setLoading(true);
    try { await inventoryAPI.adjust({ adjustment_date: adjustDate, adjustments, reason }); toast.success('Inventory adjusted'); navigate('/inventory'); } catch(err) { toast.error(err.message); } setLoading(false); };
  return (
    <div>
      <div className="toolbar"><h2>Inventory Adjustment</h2></div>
      <div className="card"><div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group"><label>Date</label><input className="form-control" type="date" value={adjustDate} onChange={e=>setAdjustDate(e.target.value)}/></div>
            <div className="form-group"><label>Reason</label><input className="form-control" value={reason} onChange={e=>setReason(e.target.value)} placeholder="Reason for adjustment"/></div>
          </div>
          <table style={{marginBottom:16}}>
            <thead><tr><th>Product</th><th style={{width:150}}>New Quantity</th><th style={{width:50}}></th></tr></thead>
            <tbody>{adjustments.map((a,i)=>(<tr key={i}>
              <td><select className="form-control" value={a.product_id} onChange={e=>update(i,'product_id',parseInt(e.target.value))}>
                <option value="">Select...</option>{products.map(p=><option key={p.id} value={p.id}>{p.name} (On hand: {p.quantity_on_hand})</option>)}</select></td>
              <td><input className="form-control" type="number" step="0.01" value={a.new_quantity} onChange={e=>update(i,'new_quantity',parseFloat(e.target.value)||0)}/></td>
              <td><button type="button" className="btn-ghost btn-sm" onClick={()=>setAdjustments(adjustments.filter((_,j)=>j!==i))}>✕</button></td>
            </tr>))}</tbody>
          </table>
          <div style={{display:'flex',gap:12}}>
            <button type="button" className="btn btn-outline btn-sm" onClick={addAdjustment}>+ Add Item</button>
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-outline" onClick={()=>navigate('/inventory')}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'Saving...':'Apply Adjustment'}</button>
          </div>
        </form>
      </div></div>
    </div>
  );
}
